import {
  SET_AUTH_USER_DATA,
  INCREMENT_APHORISMS_COUNT, DECREMENT_APHORISMS_COUNT,
  DECREMENT_FAVORITES_COUNT,
  INCREMENT_CART_COUNT,
  DECREMENT_NOTIFICATIONS_COUNT, DECREMENT_COMMENTS_COUNT,
  INCREMENT_PLAYLISTS_COUNT, DECREMENT_PLAYLISTS_COUNT,
} from "../constants/auth";
import { YANDEX } from '../../config';

const initialState = {
  isAuth: false,

  id: 0,
  slug: null,
  lang: null,
  currency: null,
  is_moderator: false,
  is_seller: false,
  // is_buyer: false,
  is_teacher: false,
  is_disciple: false,
  agree_for_promotion: true,
  balance: 0,
  payment_service: YANDEX,
  exclusive_discount: 0,
  email: null,
  avatar: null,
  full_name: null,
  first_name: null,
  last_name: null,

  yandex_saved_payment: false,
  paypal_subscription: false,

  moder_count: 0,

  possible_free_arrangement_count: 0,
  coupons_count: 0,
  favorites_count: 0,
  cart_count: 0,
  notifications_count: 0,
  messages_count: 0,
  comments_count: 0,
  aphorisms_count: 0,
  collection_arrangements_count: 0,
  collection_playlists_count: 0,
  collection_authors_count: 0,
  collection_genres_count: 0,

  can_open_online: false,
  can_download_files: false,
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_AUTH_USER_DATA:
      return {
        ...state,
        ...action.data,
      };
    case INCREMENT_APHORISMS_COUNT:
      return {
        ...state,
        aphorisms_count: state.aphorisms_count + 1
      };
    case DECREMENT_APHORISMS_COUNT:
      return {
        ...state,
        aphorisms_count: state.aphorisms_count - 1
      };

    case DECREMENT_FAVORITES_COUNT:
      return {
        ...state,
        favorites_count: state.favorites_count - action.value
      };
    case INCREMENT_CART_COUNT:
      return {
        ...state,
        cart_count: state.cart_count + action.value
      };
    case DECREMENT_NOTIFICATIONS_COUNT:
      return {
        ...state,
        notifications_count: state.notifications_count - action.value
      };
    case DECREMENT_COMMENTS_COUNT:
      return {
        ...state,
        comments_count: state.comments_count - action.value
      };

    case INCREMENT_PLAYLISTS_COUNT:
      return {
        ...state,
        collection_playlists_count: state.collection_playlists_count + 1
      };
    case DECREMENT_PLAYLISTS_COUNT:
      return {
        ...state,
        collection_playlists_count: state.collection_playlists_count - 1
      };

    default:
      return state;
  }
};

export default authReducer;